import { observable } from 'mobx';
const theDefault = {};
class ProgressStore {
  @observable state = theDefault;
  constructor() {
    const val = JSON.parse(localStorage.getItem("tune-progress"));
    if (!val) {
      this.state = theDefault;
    }
    else {
      this.state = val;
    }
  }
  markLevelPassed(level) {
    this.state[level] = true;
    localStorage.setItem("tune-progress", JSON.stringify(this.state));
  }
}
export const observableProgressStore = new ProgressStore();



// WEBPACK FOOTER //
// ./src/stores/user-level-progress-store.js